import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 64 64",
  style: {"background-color":"#ffffff00"},
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M8 40h48v20H8V40zM8 3h48v22H8V3z\" fill=\"#55acba\" stroke-linejoin=\"round\"></path><path d=\"M11 15.5h42V22H11v-6.5zm0-10h42V12H11V5.5zM11 52h42v5H11v-5zm0-9h42v5H11v-5z\" stroke=\"#fff\" stroke-width=\"2\" fill=\"#86bc4d\"></path><path d=\"M39 4v20M24 4v20\" stroke=\"#1e3951\" stroke-width=\"2\" fill=\"none\"></path><path d=\"M41 16v6m-15-6v6M41 16v6m-15-6v6M41 6v6M26 6v6M37 16v6m-15-6v6M37 6v6M22 6v6\" stroke=\"#fff\" stroke-width=\"2\" fill=\"none\"></path><path d=\"M26.954 26.5l-.017 3.53-8.093.032L31.5 40.5l13.938-10.28-9.393.01V26.5h-9.09z\" stroke=\"#fff\" stroke-width=\"2\" fill=\"#55acba\" stroke-linejoin=\"round\"></path>", 5)
  ])))
}
export default { render: render }